import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class ads
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.ads = {};

/**
 * GET Endpoint `/ads/for_widget`
 * @param {number} widget_id
 * @param {number} timestamp
 * @param {string} timezone
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.ads
 */
ReachAPI.ads.getAdsForWidget = function (widget_id, timestamp, timezone) {
    var cache_id = '/ads/widget=' + widget_id + '/timezone=' + timezone;
    var url = ReachAPI.server + '/ads/for_widget/' + widget_id;
    var params = {
        timestamp: timestamp,
        timezone: timezone,
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Ads from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Ads from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Ads',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
